"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MUTATE_UPDATE_FEEDBACK = exports.MUTATE_CREATE_FEEDBACK = void 0;
exports.MUTATE_CREATE_FEEDBACK = `
	mutation createFeedback($newFeedbackDetails: NewFeedbackDetails) {
		createFeedback(newFeedbackDetails: $newFeedbackDetails)
    }
`;
exports.MUTATE_UPDATE_FEEDBACK = `
	mutation updateFeedback($feedbackDetails: FeedbackDetails) {
		updateFeedback(feedbackDetails: $feedbackDetails)
  }
`;
//# sourceMappingURL=practical-experience-requirement.js.map